export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-styleguide-17d17ac8d9dbebb1f290ed84e595a95d.png";